/**
 * Which kind of host the app is running on (docs/Decisions.md D60 item 4).
 *
 * The same bundle serves the platform's own hosts and every organization's
 * custom-domain hosts (D46). On an organization's website host (`www` by
 * default) the app renders only that organization's template site, at the
 * root; on its portal host, and everywhere else, the full app. Pure, so it
 * is unit-tested.
 */

/** True for hosts that are the platform's own, which never ask the API. */
export function isPlatformHost(hostname, platformDomain) {
  const host = String(hostname || '').toLowerCase();
  if (!host || host === 'localhost' || host === '127.0.0.1' || host === '[::1]') return true;
  if (host.endsWith('.cloudfront.net')) return true;
  const domain = String(platformDomain || '').toLowerCase();
  return Boolean(domain) && (host === domain || host.endsWith(`.${domain}`));
}

/**
 * What to render from GET /domains/resolve's answer: `{ mode: 'website',
 * slug, portalOrigin }` for an org's website host, else `{ mode: 'app' }`.
 */
export function hostMode(resolved, platformDomain) {
  if (!resolved || resolved.type !== 'custom' || resolved.role !== 'website' || !resolved.slug) {
    return { mode: 'app' };
  }
  const portal = resolved.portalHost || platformDomain || null;
  return {
    mode: 'website',
    slug: resolved.slug,
    orgName: resolved.name || null,
    portalOrigin: portal ? `https://${portal}` : '',
  };
}

/** The portal address a website-host path that is not a site page goes to. */
export function portalUrl(portalOrigin, pathname, search = '') {
  return `${portalOrigin}${pathname || '/'}${search || ''}`;
}
